document.addEventListener( 'DOMContentLoaded', () => {
	const programSelectors = document.querySelectorAll( '.program-selector' );
	if ( !programSelectors.length ) {
		return;
	}

	programSelectors.forEach( programSelector => {
		const stateSelect = programSelector.querySelector( '.state-select' );
		const resultContainer = programSelector.querySelector( '.result-container' );
		const program = programSelector.getAttribute( 'data-program' );

		stateSelect.addEventListener( 'change', () => {
			const selectedState = stateSelect.value;
			resultContainer.innerHTML = ''; // Clear previous results

			const endpoints = [];
			switch ( program ) {
				case 'college':
					endpoints.push( `/wp-json/wdg/v1/colleges?state=${selectedState}` );
					break;
				case 'guest-speaker':
					endpoints.push( `/wp-json/wdg/v1/champions?state=${selectedState}` );
					break;
				case 'invest':
				case 'find-invest':
					endpoints.push( `/wp-json/wdg/v1/schools?state=${selectedState}` );
					endpoints.push( `/wp-json/wdg/v1/champions?state=${selectedState}` );
					break;
			}

			Promise.all( endpoints.map( endpoint => fetch( endpoint, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
				},
			} ).then( response => response.json() ) ) )
				.then( dataArray => {
					let html = '';
					const schools= dataArray.find( data => data.schools )?.schools;
					const colleges = dataArray.find( data => data.colleges )?.colleges;
					const champions= dataArray.find( data => data.champions )?.champions;

					if ( !schools?.length && !champions?.length && !colleges?.length ) {
						html += '<p>No results found.</p>';
						resultContainer.innerHTML = html;
						return;
					}

					if ( program === 'college' ) {
						html += '<h3>Colleges</h3>';
						html += '<div><table><tr><th>College</th><th>URL</th><th>City</th><th>State</th></tr>';
						colleges.forEach( college => {
							html += `<tr><td>${college.college}</td><td><a href="${college.url}">${college.url}</a></td><td>${college.city}</td><td>${college.state}</td></tr>`;
						} );
						html += '</table></div>';
					} else if ( program === 'guest-speaker' ) {
						html += '<h3>Guest Speakers</h3>';
						html += '<div><table><tr><th>Organization</th><th>Contact</th><th>Email</th><th>City</th><th>State</th></tr>';
						champions.forEach( champion => {
							html += `<tr><td>${champion.organization}</td><td>${champion.contact}</td><td><a href="mailto:${champion.email}">${champion.email}</a></td><td>${champion.city}</td><td>${champion.state}</td></tr>`;
						} );
						html += '</table></div>';
					} else if ( program === 'invest' || program === 'find-invest' ) {
						// Ensure correct ordering in the array by checking response types
						if ( champions?.length ) {
							html += '<h3>Champions</h3>';
							html += '<div><table><tr><th>Organization</th><th>Contact</th><th>Email</th><th>City</th><th>State</th></tr>';
							champions.forEach( champion => {
								html += `<tr><td>${champion.organization}</td><td>${champion.contact}</td><td><a href="mailto:${champion.email}">${champion.email}</a></td><td>${champion.city}</td><td>${champion.state}</td></tr>`;
							} );
							html += '</table></div>';
						}

						if ( schools?.length ) {
							html += '<h3>Schools</h3>';
							html += '<div><table><tr><th>School</th><th>City</th><th>State</th></tr>';
							schools.forEach( school => {
								html += `<tr><td>${school.school}</td><td>${school.city}</td><td>${school.state}</td></tr>`;
							} );
							html += '</table></div>';
						}
					}

					resultContainer.innerHTML = html;
				} )
				.catch( error => {
					console.error( 'Error fetching data:', error );
					resultContainer.innerHTML = `<p>Error fetching data: ${error.message}</p>`;
				} );
		} );
	} );
} );
